module.exports = __webpack_public_path__ + "img/swqm32.cf5e1bd0.svg";